module.exports = __webpack_public_path__ + "static/media/referralBanner-img.f255133b.svg";